'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { CreateNewUser } from '../(protected)/services/createuser/createnewuser';
import { UserInfo } from '../(protected)/models/userinfo';
import { useLoading } from '../components/PageLoading';
import Cookies from "js-cookie";

export default function LoginPage() {
  // Clear cookies on load
  Cookies.remove("authToken", { path: "/" });
  Cookies.remove("AccountId", { path: "/" });
  Cookies.remove("UserInfoUserId", { path: "/" });

  const router = useRouter();
  const { showpageloading, hidepageloading } = useLoading(); // Use context loading

  const [username, setUsername] = useState('');
  const [companyname, setcompanyname] = useState('');
  const [companyphonenumber, setcompanyphonenumber] = useState('');
  const [usermailid, setusermailid] = useState('');
  const [userphonenumber, setuserphonenumber] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    // Basic validations
    if (!companyname) { alert("Please enter company name"); return; }
    if (!username) { alert("Please enter username"); return; }
    if (!usermailid) { alert("Please enter email"); return; }
    if (!/\S+@\S+\.\S+/.test(usermailid)) { alert("Please enter valid email"); return; }
    if (!userphonenumber) { alert("Please enter user phone number"); return; }
    if (userphonenumber.replace(/\D/g, "").length < 10) { alert("Phone number is not valid!"); return; }
    if (!companyphonenumber) { alert("Please enter company phone number"); return; }
    if (companyphonenumber.replace(/\D/g, "").length < 10) { alert("Company phone number is not valid!"); return; }

    try {
      showpageloading(); // Show loader

      const userinfo: UserInfo = {
        id: 0,
        userName: username,
        emailId: usermailid,
        phoneNumber: userphonenumber,
        businessPhone: companyphonenumber,
        PreferredAccountId: 1,
        CompanyName: companyname,
        password: "",
      };

      const { Saveuserdetails } = await CreateNewUser();
      const Newuser = await Saveuserdetails(userinfo);

      if (Newuser?.id != null && Newuser.id > 0) {
        alert("User created successfully. Please create your password.");
        router.push("/forgotpassword");
      } else if (Newuser?.id != null && Newuser.id === 0) {
        alert("User already exists");
      } else {
        alert("User creation failed.");
      }

    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      hidepageloading(); // Hide loader
    }
  };

  // Phone number input handler (max 15 digits, allow +, -, (, ))
  const handlePhoneInput = (value: string, setValue: (v: string) => void) => {
    let validValue = value.replace(/[^0-9()+-\s]/g, "");
    const digits = validValue.replace(/\D/g, "");
    if (digits.length > 15) {
      let digitIndex = 0;
      validValue = validValue.replace(/\d/g, (d) => {
        digitIndex++;
        return digitIndex <= 15 ? d : "";
      });
    }
    setValue(validValue);
  };

  return (
    <main className="w-full max-w-md p-6">
      <div className="bg-white shadow-md rounded-lg px-8 py-10">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo.svg" alt="Company Logo" width={100} height={100} className="object-contain" />
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" aria-label="Login form">
          {/* Company Name */}
          <div className="relative mb-5">
            <input
              type="text"
              id="companyname"
              value={companyname}
              onChange={(e) => setcompanyname(e.target.value)}
              className="peer w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
              placeholder=" "
            />
            <label
              htmlFor="companyname"
              className="absolute left-4 -top-2 text-gray-500 text-xs transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-orange-500 bg-white px-1"
            >
              Company Name
            </label>
          </div>

          {/* Username */}
          <div className="relative mb-5">
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="peer w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
              placeholder=" "
            />
            <label htmlFor="username" className="absolute left-4 -top-2 text-gray-500 text-xs transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-orange-500 bg-white px-1">
              Username
            </label>
          </div>

          {/* User Email */}
          <div className="relative mb-5">
            <input
              type="text"
              id="usermailid"
              value={usermailid}
              onChange={(e) => setusermailid(e.target.value)}
              className="peer w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
              placeholder="User EmailId"
            />
            <label htmlFor="usermailid" className="absolute left-4 -top-2 text-gray-500 text-xs transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-orange-500 bg-white px-1">
              User EmailId
            </label>
          </div>

          {/* User Phone Number */}
          <div className="relative mb-5">
            <input
              type="text"
              id="userphonenumber"
              value={userphonenumber}
              onChange={(e) => handlePhoneInput(e.target.value, setuserphonenumber)}
              className="peer w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
              placeholder="User Phone Number"
            />
            <label htmlFor="userphonenumber" className="absolute left-4 -top-2 text-gray-500 text-xs transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-orange-500 bg-white px-1">
              User Phone Number
            </label>
          </div>

          {/* Company Phone Number */}
          <div className="relative mb-5">
            <input
              type="text"
              id="companyphonenumber"
              value={companyphonenumber}
              onChange={(e) => handlePhoneInput(e.target.value, setcompanyphonenumber)}
              className="peer w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
              placeholder="Company Phone Number"
            />
            <label htmlFor="companyphonenumber" className="absolute left-4 -top-2 text-gray-500 text-xs transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-orange-500 bg-white px-1">
              Company Phone Number
            </label>
          </div>

          {error && <p className="text-sm text-red-600">{error}</p>}

          <button
            type="submit"
            className="w-full h-[46px] bg-gradient-to-br from-orange-500 to-orange-600 text-white text-xl uppercase rounded-md flex items-center justify-center hover:from-orange-600 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-105 cursor-pointer my-1 tracking-wide"
          >
            Create User
          </button>
          <a
            href="/login"
            className="text-sm mt-2 hover:underline text-right"
          >
            Back to Login?
          </a>
        </form>
      </div>
    </main>
  );
}
